export const EQUIPMENT_TYPES = [
    { value: 'aerial_manlift', label: 'Aerial / Manlift', color: '#e65100', formType: 'aerial_lift' },
    { value: 'crane', label: 'Crane', color: '#f9a825', formType: 'crane_forklift' },
    { value: 'forklift', label: 'Forklift', color: '#7cb342', formType: 'maintenance_safety' },
];

export const FORM_TYPES = [
    { value: 'aerial_lift', label: 'Aerial Lift / Manlift', color: '#e65100' },
    { value: 'crane_forklift', label: 'D-27 Crane', color: '#f9a825' },
    { value: 'maintenance_safety', label: 'Daily & Monthly Maintenance', color: '#7cb342' },
];

export const AERIAL_LIFT_ITEMS = [
    'Operating and emergency controls in proper working condition, EMO button or Emergency Stop Device',
    'Functional upper drive control interlock (e.g. foot pedal, spring lock, or two hand controls)',
    'Emergency Lowering function operates properly',
    'Lower operating controls successfully over ride the upper controls',
    'Both upper and lower controls are adequately protected from inadvertent operation',
    'Control panel is clean & all buttons/switches are clearly visible (no paint over spray, etc.)',
    'All guards & protective guards are in good condition and properly installed',
    'All Safety Indicator lights work',
    'Drive controls function properly & accurately labeled (up, down, right, left, forward, back)',
    'Motion alarms are functional',
    'Safety decals are in place and readable',
    'All guard rails are sound and in place, including basket chains',
    'Work platform & extension slides are clean, dry, & clear of debris',
    'Work platform extension slider and roll tray with safety locking pins in place',
    'Inspect for defects such as cracked welds, fuel leaks, hydraulic leaks, damaged control cables or wire ropes',
    'Tires and wheels are in good condition, with adequate air pressure if pneumatic',
    'Braking devices are operating properly',
    'The manufacturer\'s operations manual is stored on MEWP (in all languages of the operators)',
    'Oil level, Hydraulic Oil Level, Fuel Level, Coolant Level',
    'Chains from the basket to the floor protection for SGY sensor in place',
    'Outriggers in place or functioning. Associated alarms working',
];

export const CRANE_FORKLIFT_ITEMS = [
    'Is there an operator\'s manual provided with the machine?',
    'Is there a load chart available for the machine as it is equipped?',
    'Is there an external placard displaying standard hand signals?',
    'Do the outriggers function properly when tested?',
    'Are appropriate pads available to prevent outriggers from damaging floor or roof surfaces?',
    'Are there any hydraulic leaks?',
    'Is the wire rope(s) in good condition and free of damage?',
    'Is the wire rope(s) terminated properly?',
    'Does the anti two block device function properly?',
    'Do all lights work properly?',
    'Does the horn work?',
    'Does the backup alarm work?',
    'Are safety latches or their equivalent in place and functioning?',
    'Is there a functional fire extinguisher available?',
    'Are all window panes or equivalent and free of defects?',
    'Is the machine capable of running on propane for indoor use?',
    'Is the operator properly trained for this machine?',
    'Legible hand signal chart?',
];

export const MAINTENANCE_SAFETY_ITEMS = [
    { key: 'cabProtection', label: 'Operator\'s cab protection / guards' },
    { key: 'cabWorks', label: 'Cab protection works properly' },
    { key: 'seatBelt', label: 'Seat belt' },
    { key: 'fireExtinguisher', label: 'Fire extinguisher & charge' },
    { key: 'blowOutRadiator', label: 'Check blow-out radiator' },
    { key: 'cleanCab', label: 'Clean out trash-debris inside cab' },
    { key: 'inspectBucket', label: 'Inspect bucket / attachment for visible cracks' },
    { key: 'greaseMovingParts', label: 'Grease all moving parts, attachments' },
    { key: 'tireTrackRoller', label: 'Check for tire / track / roller damage' },
    { key: 'hornFunctions', label: 'Horn functions properly' },
    { key: 'coolantOilLevels', label: 'Check coolant & oil levels' },
    { key: 'inspectBelts', label: 'Inspect belts' },
    { key: 'checkLeaks', label: 'Visually check for any leaks' },
    { key: 'cleanRollerFrames', label: 'Clean roller frames (track machines) daily' },
    { key: 'windshieldWipers', label: 'Windshield wipers function properly' },
    { key: 'hydraulicCovers', label: 'Inspect protective covers on hydraulic cylinders' },
    { key: 'backupAlarm', label: 'Back-up alarm functions properly' },
];
